import React, { useContext, useEffect, useMemo, useState } from "react";

import { useRef } from "react";
import { PopupContentContext } from "../../context/PopupContentContext";
import Modal from "../../useOss/Modal";
import "../../style/dashboard/upgrade-core.module.css";
import { getListAvailableCoreVersions } from "../../api/saas/multi-tenancy/deployment/teleport/list";
import { upgradeCoreVersion } from "../../api/saas/multi-tenancy/deployment/teleport/upgrade";
import { getTeleportStatus } from "../../api/saas/multi-tenancy/deployment/teleport/status";

const inactiveUpgradingIcon = () => {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: "4px" }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17ZM8.5 15C12.0899 15 15 12.0899 15 8.5C15 4.91015 12.0899 2 8.5 2C4.91015 2 2 4.91015 2 8.5C2 12.0899 4.91015 15 8.5 15Z"
                fill="#FF9933"
                fillOpacity="0.2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 8.5C17 8.50148 17 8.50295 17 8.50443H15C15 8.50295 15 8.50148 15 8.5C15 4.91015 12.0899 2 8.5 2V0C13.1944 0 17 3.80558 17 8.5Z"
                fill="#FF9933"
            />
        </svg>
    );
};

const getUpgradingIcon = () => {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: "6px" }}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17ZM8.5 15C12.0899 15 15 12.0899 15 8.5C15 4.91015 12.0899 2 8.5 2C4.91015 2 2 4.91015 2 8.5C2 12.0899 4.91015 15 8.5 15Z"
                fill="white"
                fillOpacity="0.2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 8.5C17 8.50148 17 8.50295 17 8.50443H15C15 8.50295 15 8.50148 15 8.5C15 4.91015 12.0899 2 8.5 2V0C13.1944 0 17 3.80558 17 8.5Z"
                fill="white"
            />
        </svg>
    );
};
const getUpgradeIcon = (active: boolean) => {
    return !active ? (
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_14978_129009"
                style={{ maskType: "luminance" }}
                maskUnits="userSpaceOnUse"
                x={0}
                y={0}
                width={14}
                height={15}
            >
                <path d="M14 0.328125H0V14.3281H14V0.328125Z" fill="white" />
            </mask>
            <g mask="url(#mask0_14978_129009)">
                <path
                    d="M6.9974 13.1628C10.2191 13.1628 12.8307 10.5511 12.8307 7.32943C12.8307 4.10777 10.2191 1.49609 6.9974 1.49609C3.77574 1.49609 1.16406 4.10777 1.16406 7.32943C1.16406 10.5511 3.77574 13.1628 6.9974 13.1628Z"
                    stroke="#FF8A15"
                    strokeWidth="1.51667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.33073 7.32943L6.9974 4.99609L4.66406 7.32943"
                    stroke="#FF8A15"
                    strokeWidth="1.51667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7 9.66276V4.99609"
                    stroke="#FF8A15"
                    strokeWidth="1.51667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    ) : (
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_14990_125810)">
                <mask
                    id="mask0_14990_125810"
                    style={{ maskType: "luminance" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="14"
                    height="15"
                >
                    <path d="M14 0.328125H0V14.3281H14V0.328125Z" fill="white" />
                </mask>
                <g mask="url(#mask0_14990_125810)">
                    <path
                        d="M6.9974 13.1628C10.2191 13.1628 12.8307 10.5511 12.8307 7.32943C12.8307 4.10777 10.2191 1.49609 6.9974 1.49609C3.77574 1.49609 1.16406 4.10777 1.16406 7.32943C1.16406 10.5511 3.77574 13.1628 6.9974 13.1628Z"
                        stroke="white"
                        strokeWidth="1.51667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.33073 7.32943L6.9974 4.99609L4.66406 7.32943"
                        stroke="white"
                        strokeWidth="1.51667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M7 9.66276V4.99609"
                        stroke="white"
                        strokeWidth="1.51667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_14990_125810">
                    <rect width="14" height="14" fill="white" transform="translate(0 0.328125)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export function UpgradeCoreVersionModal({
    isModalOpen,
    closeModal,
    version,
    isProductionInstance,
    latestCoreVersion,
    onComplete
}: {
    isModalOpen: boolean;
    closeModal: () => void;
    version: string | undefined;
    isProductionInstance: boolean;
    latestCoreVersion: string | undefined;
    onComplete: (status?: "upgrading" | "not-upgrading") => void;
}) {
    const [state, setState] = useState<"LOADING" | "SUCCESS" | "ERROR">("LOADING");
    const [availableCoreVersions, setAvailableCoreVersions] = useState<string[]>([]);
    const [selectedVersion, setSelectedVersion] = useState<string | undefined>(undefined);
    const [coreUpgradeState, setCoreUpgradeState] = useState<"IDLE" | "UPGRADING" | "UPGRADED">("IDLE");
    const { showToast } = useContext(PopupContentContext);
    const [isLatestCoreVersion, setIsLatestCoreVersion] = useState(latestCoreVersion === version);

    function close() {
        onComplete(coreUpgradeState === "UPGRADING" ? "upgrading" : "not-upgrading");
        closeModal();
    }

    useEffect(() => {
        setState("LOADING");
        async function fetchAvailableCoreVersions() {
            try {
                const data = await getListAvailableCoreVersions({
                    deploymentType: isProductionInstance ? "production" : "development"
                });
                setAvailableCoreVersions(data.coreVersions);
                setState("SUCCESS");
            } catch (error) {
                setState("ERROR");
            }
        }
        fetchAvailableCoreVersions();
    }, []);

    async function handleUpgradeCoreVersion() {
        if (!version || !selectedVersion || coreUpgradeState === "UPGRADING") return;
        setCoreUpgradeState("UPGRADING");
        try {
            await upgradeCoreVersion({
                targetCoreVersionX2: selectedVersion,
                deploymentType: isProductionInstance ? "production" : "development"
            });

            const POLLING_INTERVAL = 3000;
            while (true) {
                const status = await getTeleportStatus({
                    deploymentType: isProductionInstance ? "production" : "development"
                });

                if (status.status === "finished") {
                    onComplete("not-upgrading");
                    showToast({
                        status: "success",
                        icon: `/static/assets/dashboard/check-rounded-green.png`,
                        children: <>Core upgraded successfully to v{selectedVersion}</>
                    });
                    setIsLatestCoreVersion(selectedVersion === latestCoreVersion);
                    setCoreUpgradeState("UPGRADED");
                    return;
                }

                await new Promise(resolve => setTimeout(resolve, POLLING_INTERVAL));
            }
        } catch (error) {
            onComplete();
            showToast({
                status: "error",
                icon: `/static/assets/dashboard/red-issue.png`,
                children: <>An error occurred while upgrading core.</>
            });
            setCoreUpgradeState("IDLE");
        }
    }

    const ModalHeader = () => {
        return (
            <section className="upgrade-core-version-modal-header">
                <div className="upgrade-core-version-modal-header-left">
                    <h4>Upgrade Core</h4>
                    <div className={`core-current-version ${isLatestCoreVersion ? "latest" : ""}`}>
                        {isLatestCoreVersion ? (
                            <>
                                <span>Latest</span>
                                <span>v{latestCoreVersion}</span>
                            </>
                        ) : (
                            <>
                                <span>Current</span>
                                <span>v{version}</span>
                            </>
                        )}
                    </div>
                </div>
                <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={() => close()}
                    style={{ cursor: "pointer" }}
                >
                    <path
                        d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
                        fill="#E8E8E8"
                    />
                    <path
                        d="M7.2481 14.89C7.40424 15.0431 7.61474 15.1279 7.83337 15.1258C8.052 15.1238 8.26088 15.035 8.4141 14.879L11.0041 12.239L13.5951 14.879C13.6699 14.9606 13.7604 15.0264 13.8611 15.0723C13.9618 15.1182 14.0708 15.1433 14.1814 15.1463C14.2921 15.1492 14.4022 15.1298 14.5052 15.0893C14.6082 15.0488 14.7021 14.9879 14.7811 14.9104C14.8601 14.8329 14.9227 14.7402 14.9651 14.638C15.0076 14.5357 15.029 14.426 15.0282 14.3153C15.0274 14.2046 15.0043 14.0952 14.9603 13.9936C14.9163 13.8921 14.8523 13.8004 14.7721 13.724L12.1601 11.063L14.7721 8.40103C14.9167 8.24332 14.9943 8.03562 14.9887 7.82175C14.983 7.60787 14.8945 7.40456 14.7418 7.25471C14.5891 7.10486 14.3841 7.0202 14.1702 7.01858C13.9562 7.01696 13.7501 7.09851 13.5951 7.24603L11.0041 9.88603L8.4141 7.24603C8.3393 7.16443 8.24883 7.09872 8.14809 7.05281C8.04736 7.0069 7.93841 6.98173 7.82775 6.9788C7.71709 6.97588 7.60698 6.99526 7.50396 7.03578C7.40094 7.0763 7.30712 7.13714 7.22811 7.21467C7.1491 7.29221 7.0865 7.38485 7.04405 7.48709C7.00159 7.58932 6.98014 7.69907 6.98098 7.80977C6.98182 7.92046 7.00493 8.02986 7.04893 8.13144C7.09293 8.23302 7.15692 8.3247 7.2371 8.40103L9.8491 11.063L7.2371 13.724C7.08405 13.8802 6.99924 14.0907 7.00131 14.3093C7.00337 14.5279 7.09214 14.7368 7.2481 14.89Z"
                        fill="#6E6A65"
                    />
                </svg>
            </section>
        );
    };

    const ModalCTA = () => {
        const isUpgradeCompleted = coreUpgradeState === "UPGRADED";
        console.log(coreUpgradeState);

        return isUpgradeCompleted ? (
            <button className="upgrade-core-version-btn" onClick={() => close()}>
                Done
            </button>
        ) : (
            <button
                className="upgrade-core-version-btn"
                disabled={!version || !selectedVersion || coreUpgradeState === "UPGRADING"}
                onClick={() => handleUpgradeCoreVersion()}
            >
                {coreUpgradeState === "UPGRADING" ? (
                    <>
                        {getUpgradingIcon()}
                        Upgrading
                    </>
                ) : (
                    "Upgrade"
                )}
            </button>
        );
    };

    const ModalBody = useMemo(() => {
        const isUpgradeCompleted = coreUpgradeState === "UPGRADED";
        return isUpgradeCompleted ? (
            <div className="upgrade-core-version-modal-main-content">
                <div className="upgrade-core-version-modal-main-content-success">
                    <span>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M8.00209 15.0061C11.8714 15.0061 15.0081 11.8698 15.0081 8.00109C15.0081 4.13234 11.8714 0.996094 8.00209 0.996094C4.13279 0.996094 0.996094 4.13234 0.996094 8.00109C0.996094 11.8698 4.13279 15.0061 8.00209 15.0061Z"
                                fill="#30C48D"
                            />
                            <path
                                d="M9.15051 6.06008L7.45051 8.56008L6.95051 8.06008C6.76422 7.87751 6.51341 7.77585 6.25258 7.77716C5.99175 7.77848 5.74198 7.88268 5.55754 8.06711C5.37311 8.25155 5.26891 8.50132 5.26759 8.76215C5.26627 9.02298 5.36794 9.27379 5.55051 9.46008L6.95051 10.8601C7.0385 10.9578 7.14667 11.0352 7.26753 11.087C7.3884 11.1388 7.51907 11.1637 7.65051 11.1601H7.75051C7.89133 11.1573 8.0292 11.1192 8.15149 11.0493C8.27379 10.9794 8.3766 10.88 8.45051 10.7601L10.8505 7.16008C10.9964 6.93465 11.0467 6.6605 10.9905 6.39795C10.9342 6.1354 10.7759 5.90595 10.5505 5.76008C10.4389 5.68785 10.3141 5.63832 10.1834 5.61431C10.0526 5.59029 9.91838 5.59227 9.78838 5.62013C9.52582 5.67639 9.29638 5.83464 9.15051 6.06008Z"
                                fill="white"
                            />
                            <path
                                d="M15.0459 5.76189C14.8956 5.61615 14.7758 5.442 14.6934 5.24956C14.611 5.05712 14.5676 4.85022 14.5659 4.64089C14.563 3.79309 14.2249 2.98084 13.6254 2.38135C13.0259 1.78186 12.2137 1.44379 11.3659 1.44089C11.1566 1.43913 10.9497 1.3958 10.7572 1.31339C10.5648 1.23099 10.3906 1.11117 10.2449 0.960889C9.94785 0.656732 9.59299 0.415039 9.20118 0.250023C8.80938 0.0850075 8.38853 0 7.96339 0C7.53825 0 7.1174 0.0850075 6.72559 0.250023C6.33379 0.415039 5.97893 0.656732 5.68189 0.960889C5.55705 1.11566 5.39816 1.23951 5.21759 1.32277C5.03702 1.40603 4.83965 1.44645 4.64089 1.44089C3.79309 1.44379 2.98084 1.78186 2.38135 2.38135C1.78186 2.98084 1.44379 3.79309 1.44089 4.64089C1.43913 4.85022 1.3958 5.05712 1.31339 5.24956C1.23099 5.442 1.11117 5.61615 0.960889 5.76189C0.656732 6.05893 0.415039 6.41379 0.250023 6.80559C0.0850075 7.1974 0 7.61825 0 8.04339C0 8.46853 0.0850075 8.88938 0.250023 9.28119C0.415039 9.67299 0.656732 10.0278 0.960889 10.3249C1.11117 10.4706 1.23099 10.6448 1.31339 10.8372C1.3958 11.0297 1.43913 11.2366 1.44089 11.4459C1.44379 12.2937 1.78186 13.1059 2.38135 13.7054C2.98084 14.3049 3.79309 14.643 4.64089 14.6459C4.85022 14.6476 5.05712 14.691 5.24956 14.7734C5.442 14.8558 5.61615 14.9756 5.76189 15.1259C6.37666 15.679 7.17009 15.9921 7.99689 16.0079C8.41663 16.0117 8.83258 15.9283 9.21836 15.7628C9.60414 15.5974 9.95133 15.3536 10.2379 15.0469C10.3836 14.8966 10.5578 14.7768 10.7502 14.6944C10.9427 14.612 11.1496 14.5686 11.3589 14.5669C12.2067 14.564 13.0189 14.2259 13.6184 13.6264C14.2179 13.0269 14.556 12.2147 14.5589 11.3669C14.5696 10.9602 14.7097 10.5675 14.9589 10.2459C15.2766 9.96784 15.5327 9.6265 15.7109 9.24374C15.889 8.86098 15.9853 8.44523 15.9935 8.02312C16.0017 7.60101 15.9216 7.18184 15.7584 6.79245C15.5953 6.40307 15.3526 6.05205 15.0459 5.76189ZM13.9249 9.12389C13.6243 9.4152 13.3846 9.7633 13.2196 10.148C13.0546 10.5327 12.9677 10.9463 12.9639 11.3649C12.9623 11.7887 12.7932 12.1948 12.4935 12.4945C12.1938 12.7942 11.7877 12.9633 11.3639 12.9649C10.943 12.9532 10.5247 13.0331 10.1378 13.1991C9.75083 13.365 9.40456 13.613 9.12289 13.9259C8.9784 14.0777 8.80457 14.1985 8.61195 14.2811C8.41934 14.3637 8.21196 14.4063 8.00239 14.4063C7.79282 14.4063 7.58544 14.3637 7.39282 14.2811C7.20021 14.1985 7.02638 14.0777 6.88189 13.9259C6.59058 13.6253 6.24248 13.3856 5.85778 13.2206C5.47308 13.0556 5.05945 12.9687 4.64089 12.9649C4.21703 12.9633 3.81098 12.7942 3.51126 12.4945C3.21155 12.1948 3.04247 11.7887 3.04089 11.3649C3.05254 10.944 2.97264 10.5257 2.80671 10.1388C2.64078 9.75183 2.39279 9.40556 2.07989 9.12389C1.92823 8.97932 1.80749 8.80547 1.72499 8.61287C1.6425 8.42026 1.59996 8.21292 1.59996 8.00339C1.59996 7.79386 1.6425 7.58652 1.72499 7.39391C1.80749 7.20131 1.92823 7.02746 2.07989 6.88289C2.38047 6.59158 2.6202 6.24348 2.78517 5.85878C2.95014 5.47408 3.03706 5.06045 3.04089 4.64189C3.04247 4.21803 3.21155 3.81198 3.51126 3.51226C3.81098 3.21255 4.21703 3.04347 4.64089 3.04189C5.06173 3.05354 5.48009 2.97364 5.86702 2.80771C6.25395 2.64178 6.60022 2.39379 6.88189 2.08089C7.02646 1.92923 7.20031 1.80849 7.39291 1.72599C7.58552 1.6435 7.79286 1.60096 8.00239 1.60096C8.21192 1.60096 8.41926 1.6435 8.61187 1.72599C8.80447 1.80849 8.97832 1.92923 9.12289 2.08089C9.4142 2.38147 9.7623 2.6212 10.147 2.78617C10.5317 2.95114 10.9453 3.03806 11.3639 3.04189C11.7877 3.04347 12.1938 3.21255 12.4935 3.51226C12.7932 3.81198 12.9623 4.21803 12.9639 4.64189C12.9522 5.06273 13.0321 5.48109 13.1981 5.86802C13.364 6.25495 13.612 6.60122 13.9249 6.88289C14.0766 7.02746 14.1973 7.20131 14.2798 7.39391C14.3623 7.58652 14.4048 7.79386 14.4048 8.00339C14.4048 8.21292 14.3623 8.42026 14.2798 8.61287C14.1973 8.80547 14.0766 8.97932 13.9249 9.12389Z"
                                fill="#30C48D"
                            />
                        </svg>
                    </span>{" "}
                    <span>Core updated successfully!</span>
                </div>
            </div>
        ) : (
            <div className="upgrade-core-version-modal-main-content">
                <label htmlFor="core-version">Select core version</label>
                <select
                    id="core-version"
                    name="core-version"
                    onChange={e => setSelectedVersion(e.target.value)}
                    value={selectedVersion || ""}
                >
                    <option value="" disabled>
                        Choose version
                    </option>
                    {availableCoreVersions.map(version => (
                        <option key={version} value={version}>
                            v{version}
                        </option>
                    ))}
                </select>
            </div>
        );
    }, [state, selectedVersion, availableCoreVersions, coreUpgradeState]);

    return (
        <Modal show={isModalOpen} modalClosed={() => close()} className={`${!isModalOpen && "hide"}`}>
            <div className="upgrade-core-version-modal">
                <ModalHeader />
                <section className={`upgrade-core-version-modal-body ${state === "LOADING" ? "loading" : ""}`}>
                    {ModalBody}
                    <div className="upgrade-core-version-modal-footer">
                        <ModalCTA />
                    </div>
                </section>
            </div>
        </Modal>
    );
}

export const UpgradeCoreVersion = ({
    version,
    isProductionInstance,
    latestCoreVersion
}: {
    version: string | undefined;
    isProductionInstance: boolean;
    latestCoreVersion: string | undefined;
}) => {
    const upgradeRef = useRef(null);
    const [isActive, setIsActive] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUpgrading, setIsUpgrading] = useState(false);

    async function checkUpgradeStatus(optimisticValue?: "upgrading" | "not-upgrading") {
        if (optimisticValue === "upgrading") {
            setIsUpgrading(true);
        } else if (optimisticValue === "not-upgrading") {
            setIsUpgrading(false);
        }
        const status = await getTeleportStatus({
            deploymentType: isProductionInstance ? "production" : "development"
        });
        if (status.status !== "finished") {
            setIsUpgrading(true);
        } else {
            setIsUpgrading(false);
        }
    }

    useEffect(() => {
        checkUpgradeStatus();
    }, []);

    return (
        <>
            <button
                className={`update-core-version ${isUpgrading ? "disabled" : ""}`}
                ref={upgradeRef}
                onMouseEnter={() => setIsActive(true)}
                onMouseLeave={() => setIsActive(false)}
                onClick={() => setIsModalOpen(true)}
            >
                {isUpgrading ? (
                    <>
                        {inactiveUpgradingIcon()}
                        Upgrading
                    </>
                ) : (
                    <>
                        {getUpgradeIcon(isActive)}
                        Upgrade
                    </>
                )}
            </button>
            {isModalOpen && (
                <UpgradeCoreVersionModal
                    isModalOpen={isModalOpen}
                    closeModal={() => setIsModalOpen(false)}
                    version={version}
                    isProductionInstance={isProductionInstance}
                    latestCoreVersion={latestCoreVersion}
                    onComplete={() => {
                        setIsModalOpen(false);
                        checkUpgradeStatus();
                    }}
                />
            )}
        </>
    );
};
